import React, { Component } from 'react';
import { Container, Row, Col } from '@bootstrap-styled/v4';
import { SectionHeading } from '../Common/common.style';
import {
    ContactSection, ContactInner, ContactLeft, InputField, ContactSpanErr, ContactSpanSuccess,
    TextArea, SubmitBtn, ContactRight, ContactRightRow, ContactRightImgHolder, FormGroup, Form, SendIcon,
    ContactRightImg, ContactRightTextHolder, ContactRightText, ContactRightPara, ContactRightHeading, ContactRow
} from './contact.style';
import Fade from "react-reveal/Fade";
import ReCAPTCHA from 'react-google-recaptcha';
import { StaticQuery, graphql } from 'gatsby';
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const WRNG_MSG_TIMEOUT = 3000;

class Contact extends Component {

    _googleRef = null;


    constructor() {
        super();
        this.state = {
            contact_name: "",
            contact_email: "",
            contact_message: "",
            errors: [],
            sending: false
        }

        this._googleRef = React.createRef();
        this.contactUsSubmit = this.contactUsSubmit.bind(this);
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    validateForm() {
        var error_flag = false;
        let errors = {};
        if (this.state.contact_name === "") {
            error_flag = true;
            errors['contact_name'] = "Please enter full name!";
            setTimeout(function () {
                this.setState({ errors: {} });
            }.bind(this), WRNG_MSG_TIMEOUT);
        }

        if (this.state.contact_email === "") {
            error_flag = true;
            errors['contact_email'] = "Please enter email!";
            setTimeout(function () {
                this.setState({ errors: {} });
            }.bind(this), WRNG_MSG_TIMEOUT);
        }
        if (this.state.contact_email !== "") {
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(this.state.contact_email)) {
                error_flag = true;
                errors["contact_email"] = "Please enter valid email ID!";
                setTimeout(function () {
                    this.setState({ errors: {} });
                }.bind(this), WRNG_MSG_TIMEOUT);
            }
        }

        if (this.state.contact_message === "") {
            error_flag = true;
            errors["contact_message"] = "Please enter message!";
            setTimeout(function () {
                this.setState({ errors: {} });
            }.bind(this), WRNG_MSG_TIMEOUT);
        }

        this.setState({
            errors: errors
        });
        return error_flag;
    }

    contactUsSubmit = (e) => {
        e.preventDefault();
        document.getElementById("success_contact_message").innerHTML = "";
        const recaptchaValue = this._googleRef.current.getValue();
        if (recaptchaValue) {
            if (!this.validateForm()) {
                this.setState({sending: true});
                axios.post(`https://api.dockeeper.io/api/Email/WebSupport?recaptcha=${recaptchaValue}`, {
                    fromEmail: this.state.contact_email,
                    subject: `Support message from webpage - ${this.state.contact_name}`,
                    Message: this.state.contact_message
                }).then(() => {
                    this.setState({
                        contact_name: "",
                        contact_email: "",
                        contact_message: "",
                        errors: [],
                        sending: false
                    });
                    document.getElementById("success_contact_message").innerHTML = "Email sent";
                    setTimeout(() => {
                        document.getElementById("success_contact_message").innerHTML = "";
                    }, 5000);

                }).catch(() => {
                    this.setState({
                        sending: false
                    })
                    document.getElementById("success_contact_message").innerHTML = "Error sending email.";
                });
            }
        } else {
            document.getElementById("success_contact_message").innerHTML = "Error with captcha";

            setTimeout(() => {
                document.getElementById("success_contact_message").innerHTML = "";
            }, 5000);
        }
    }

    render() {
        return (
            <ContactSection id="contactContainer">
                <Container>
                    <Row>
                        <Col md="12">
                            <Fade bottom delay={1 * this.props.saasJson.ContactUs.DelayConstant}>
                                <SectionHeading>{this.props.saasJson.ContactUs.SectionHeading}</SectionHeading>
                            </Fade>
                        </Col>
                    </Row>
                    <ContactInner>
                        <ContactRow>
                            <Col md="7">
                                <ContactLeft>
                                    <Form id="contactForm" method="post" onSubmit={this.contactUsSubmit}>
                                        <Fade left delay={1 * this.props.saasJson.ContactUs.DelayConstant}>
                                            <FormGroup>
                                                <InputField placeholder="Full Name" name="contact_name" onChange={this.handleChange} value={this.state.contact_name}></InputField>
                                                <ContactSpanErr id="err_contact_name">{this.state.errors.contact_name}</ContactSpanErr>
                                            </FormGroup>
                                        </Fade>
                                        <Fade left delay={2 * this.props.saasJson.ContactUs.DelayConstant}>
                                            <FormGroup>
                                                <InputField placeholder="Email" name="contact_email" onChange={this.handleChange} value={this.state.contact_email}></InputField>
                                                <ContactSpanErr id="err_contact_email">{this.state.errors.contact_email}</ContactSpanErr>
                                            </FormGroup>
                                        </Fade>
                                        <Fade left delay={3 * this.props.saasJson.ContactUs.DelayConstant}>
                                        </Fade>
                                        <Fade left delay={4 * this.props.saasJson.ContactUs.DelayConstant}>
                                            <FormGroup>
                                                <TextArea placeholder="Message" name="contact_message" onChange={this.handleChange} value={this.state.contact_message}></TextArea>
                                                <ContactSpanErr id="err_contact_message">{this.state.errors.contact_message}</ContactSpanErr>
                                            </FormGroup>
                                        </Fade>

                                        <Fade left delay={5 * this.props.saasJson.ContactUs.DelayConstant}>
                                            <SubmitBtn type="submit" >
                                                {this.state.sending && <FontAwesomeIcon icon={faSpinner} spin />}
                                                {!this.state.sending && <>Submit <SendIcon /></>}
                                            </SubmitBtn>

                                            <ReCAPTCHA
                                                sitekey="6LcJfXkUAAAAAEDyjhJ2wSgQQmX9-q260IXuHKv1"
                                                ref={this._googleRef}
                                            />

                                        </Fade>
                                        <ContactSpanSuccess id="success_contact_message"></ContactSpanSuccess>
                                    </Form>
                                </ContactLeft>
                            </Col>
                            <Col md="5">
                                <ContactRight>
                                    <Fade right delay={1 * this.props.saasJson.ContactUs.DelayConstant}>
                                        <ContactRightHeading>{this.props.saasJson.ContactUs.ContactRight.ContactRightHeading}</ContactRightHeading>
                                    </Fade>
                                    <Fade right delay={2 * this.props.saasJson.ContactUs.DelayConstant}>
                                        <ContactRightPara>{this.props.saasJson.ContactUs.ContactRight.ContactRightPara}</ContactRightPara>
                                    </Fade>
                                    {
                                        this.props.saasJson.ContactUs.ContactRight.ContactRightRow.map((item, idx) => {
                                            return <Fade key={idx} right delay={(idx + 3) * this.props.saasJson.ContactUs.DelayConstant}>
                                                <ContactRightRow>
                                                    <ContactRightImgHolder>
                                                        <ContactRightImg src={item.ContactRightImg} alt="" />
                                                    </ContactRightImgHolder>
                                                    <ContactRightTextHolder>
                                                        <ContactRightText>
                                                            {item.ContactRightText}
                                                        </ContactRightText>
                                                    </ContactRightTextHolder>
                                                </ContactRightRow>
                                            </Fade>
                                        })
                                    }
                                </ContactRight>
                            </Col>
                        </ContactRow>
                    </ContactInner>
                </Container>
            </ContactSection>
        )
    }
}

export default () => (
    <StaticQuery
        query={graphql`
            query {
                    saasJson{
                        ContactUs{
                            SectionHeading
                            SectionSubHeading
                            ContactRight{
                                ContactRightHeading
                                ContactRightPara
                                ContactRightRow{
                                    ContactRightImg
                                    ContactRightText
                                }
                            }
                        }
                    }
                }
            
        `}
        render={(data) => (
            <Contact saasJson={data.saasJson} />
        )}
    />
)